export const BLOCK_TYPE_PERSON_LIST_SELECTION = 'personListSelection';
